/**
 * Make a GET request
 * @param path
 * @param query
 * @returns {Promise}
 */

function get(path, query={}) {
    return new Promise((resolve, reject) => {
        const request = new XMLHttpRequest();

        request.addEventListener('load', () => {
            try {
                const body = JSON.parse(request.responseText)

                if (request.status === 200) {
                    resolve(body)
                } else {
                    console.log('err', request.responseText)
                    reject(body.error)
                }
            } catch (err) {
                console.log('err', err)
                reject('internal_server_error')
            }
        });

        request.addEventListener('error', () => {
            reject('no_connection');
        });

        request.open('GET', API_URL + path);
        request.send();
    });
}

/**
 * Make a POST request
 * @param path
 * @param body
 * @returns {Promise}
 */

function post(path, body={}) {
    return new Promise((resolve, reject) => {
        const request = new XMLHttpRequest();

        request.addEventListener('load', () => {
            try {
                const body = JSON.parse(request.responseText)

                if (request.status === 200) {
                    resolve(body)
                } else {
                    console.log('err', body)
                    reject(body.error)
                }
            } catch (err) {
                console.log('err', err)
                reject('internal_server_error')
            }
        });

        request.addEventListener('error', () => {
            reject('no_connection');
        });

        request.open('POST', API_URL + path);
        request.setRequestHeader('Content-Type', 'application/json');
        request.send(JSON.stringify(body));
    });
}

/**
 * Requests
 */

export default {
    /**
     * Get event data by id
     * @param id
     * @returns {Promise}
     */

    getEvent(id) {
        return get(`events/${id}`);
    },

    /**
     * Get team data by id
     * @param id
     * @returns {Promise}
     */

    getTeam(id) {
        return get(`teams/${id}`);
    },

    /**
     * Create a new team
     * @param eventId
     * @param name
     * @returns {Promise}
     */

    createTeam(eventId, name) {
        return post('teams/new', {event: eventId, name});
    },

    /**
     * Send an answer
     * @returns {Promise}
     */

    sendAnswer(eventId, teamId, questionId, answer) {
        return post('play/answer', {
            event: eventId,
            team: teamId,
            question: questionId,
            answer
        });
    }
}


// WEBPACK FOOTER //
// ./src/api.js